<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Perfil"
              v-model="form.filters.nome"
              outlined
              @keyup.enter="buscarPerfis"
              dense
            ></v-text-field>
          </v-col>
          <sca-select-ativo
            :cols="3"
            :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
            v-model="form.filters.ativo"
            @enter="buscarPerfis"
          ></sca-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarPerfis()"
              ></sca-tooltip>
            <sca-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterPerfil()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="headers"
        :items="form.lists.listPerfis"
        :items-per-page="10"
        :footer-props="$footerProps"
        show-expand
        :no-data-text="noDataText"
      >
        <template v-slot:[`item.nome`]="{ item }">
          {{ item.nome }}
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td class="grupos" :colspan="headers.length">
            <v-chip-group active-class="primary--text" column>
              <v-chip class="chip-permissao" v-for="(grupo, i) in item.grupos" :key="i">
                <v-icon class="grupo" small>
                  mdi-checkbox-marked-circle-outline
                </v-icon>
                {{ grupo.nomeDeExibicao }}
              </v-chip>
            </v-chip-group>
          </td>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sca-tooltip
            :text="'Visualizar'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarPerfil(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="'Editar'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="openDialogManterPerfil(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="`${item.ativo ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.ativo ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`"
            :small="true"
            @click="inativarAtivarPerfil(item)"
          ></sca-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarPerfilDialog
      :visible="dialogManterPerfil.visible"
      :content="dialogManterPerfil.content"
      :edit="dialogManterPerfil.edit"
      @onClose="dialogManterPerfil.close()"
      @onSave="buscarPerfis()"
    ></CadastrarEditarPerfilDialog>
    <VisualizarPerfilDialog
      :visible="dialogVisualizarPerfil.visible"
      :content="dialogVisualizarPerfil.content"
      @onClose="dialogVisualizarPerfil.close()"
    ></VisualizarPerfilDialog>
  </div>
</template>

<script>
import { Dialog } from '~/commons/classes/dialog';
import { Perfil } from '~/commons/classes/perfil';
import PerfilService from '~/services/perfil.service';
import CadastrarEditarPerfilDialog from "./dialogs/CadastrarEditarPerfilDialog.vue";
import VisualizarPerfilDialog from "./dialogs/VisualizarPerfilDialog.vue";
import DataTable from '~/mixins/datatables.mixin'

export default {
  name: "ManterPerfisView",
  mixins: [PerfilService, DataTable],
  components: {
    CadastrarEditarPerfilDialog,
    VisualizarPerfilDialog,
  },
  data: () => ({
    dialogManterPerfil: Dialog.Build(),
    dialogVisualizarPerfil: Dialog.Build(),
    form: {
      filters: {
        nome: null,
        ativo: null,
      },
      lists: {
        listPerfis: []
      }
    },
    headers: [
      { text: "Nome do Perfil", align: "center", value: "nome" },
      { text: "Situação", align: "center", value: "ativo", sortable: false },
      { text: "Grupos", align: "center", value: "data-table-expand" },
      { text: "Ações", align: "center", value: "acoes", sortable: false },
    ]
  }),
  methods: {
    openDialogManterPerfil(perfil) {
      perfil
        ? this.$visualizarPerfil(perfil).then(({ data }) => this.dialogManterPerfil.open(new Perfil(data.resposta.perfil), true))
        : this.dialogManterPerfil.open(Perfil.Build());
    },
    openDialogVisualizarPerfil(perfil) {
      this.$visualizarPerfil(perfil).then(({ data }) => this.dialogVisualizarPerfil.open(data.resposta.perfil));
    },
    buscarPerfis() {
      this.$buscarPerfis({ params: this.form.filters }).then(({ data }) => this.form.lists.listPerfis = data.resposta);
    },
    inativarAtivarPerfil(perfil) {
      this.$swal({
        text: `Deseja ${perfil.ativo ? "inativar" : "ativar"} o registro?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$inativarAtivarPerfil(perfil.id).then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.buscarPerfis();
        });
      });
    },
    resetForm() {
      this.$resetForm();
      this.form.lists.listPerfis = [];
      this.form.filters.ativo = null;
    },
  },
};
</script>
